<template>
<div>
  <label v-if="label">{{label}}</label>
  <b-input-group>
    <b-form-input type="text" v-model="timeValue" placeholder="HH:MM" class="xx" :disabled="disabled"></b-form-input>
    <b-input-group-append>
      <b-form-timepicker 
        v-model="pickerValue" 
        button-only 
        locale="fi" 
        :disabled="disabled" 
        :reset-button="resetButton" 
        :now-button="nowButton" 
        :label-now-button="$t('button.now')" 
        :label-close-button="$t('button.close')" 
        :label-reset-button="$t('button.reset')" >
      </b-form-timepicker>
    </b-input-group-append>
  </b-input-group>
  
</div>
</template>

<script>
import moment from "moment";
import { debounce } from '@/util/debounce';
export default {
  name: 'TimeInput',
  props: {
   label: String,
   value: { type: String, default: ''},
   disabled: { type: Boolean, default: false },
   resetButton: { type: Boolean, default: false },
   nowButton: {type: Boolean, default: false},
   format: {type: String, default: "H:mm"},
  },
  data() {
      return {
        timeValue: null,
        pickerValue: null
      }
  },
  created: function() {
    this.timeValue = this.$props.value; 
    this.debouncedEmitInput = debounce(this.emitInput, 1500);
  },
  watch: {
    pickerValue: function(value) {
      if(value == ""){
        this.timeValue = value;
        this.$emit("input", value);
        return;
      }
      var aika = new moment(value, "HH:mm:ss");
      this.timeValue = aika.format(this.format);
      this.debouncedEmitInput();
    },
    timeValue: function() {
      this.debouncedEmitInput();
    },
    value: function(newValue) {
      var aika = new moment(newValue, "HH:mm:ss");
      this.timeValue = aika.format(this.format);
      this.$emit("input", this.timeValue);
    }
  },
  methods: {
    emitInput() {
      this.$emit("input", this.timeValue);
      this.pickerValue = this.timeValue;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/*div.ownTimeButton button {*/
.btn, .base-btn, .navbar .navbar-nav > a.btn {
  margin-top: 0em;
}


</style>
